"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _omit = _interopRequireDefault(require("lodash/omit"));

var _ifOnly = _interopRequireDefault(require("if-only"));

var _enhanceFormControl = _interopRequireDefault(require("./enhance-form-control"));

var _ErrorLabel = _interopRequireDefault(require("./ErrorLabel"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var className = function className(props) {
  return (0, _classnames.default)('Select', {
    'Select--with-errors': props.error,
    'Select--disabled': props.disabled
  }, props.className);
};

var Select = function Select(props) {
  var _props$value = props.value,
      value = _props$value === void 0 ? ' -- ' : _props$value,
      _props$values = props.values,
      values = _props$values === void 0 ? [] : _props$values,
      children = props.children,
      _props$valueKey = props.valueKey,
      valueKey = _props$valueKey === void 0 ? 'value' : _props$valueKey,
      _props$labelKey = props.labelKey,
      labelKey = _props$labelKey === void 0 ? 'label' : _props$labelKey,
      error = props.error,
      _onChange = props.onChange,
      style = props.style,
      placeholder = props.placeholder;
  return _react.default.createElement("div", null, _react.default.createElement("div", {
    className: className(props)
  }, _react.default.createElement("select", _extends({}, (0, _omit.default)(props, ['valueKey', 'error']), {
    onChange: function onChange(e) {
      return _onChange(e.target.value, e.target.name);
    },
    className: "Select__select",
    style: style
  }), children, !value ? _react.default.createElement("option", {
    key: values.length,
    value: " -- "
  }, placeholder ? placeholder : '--') : void 0, values && values.map(function (value, i) {
    return _react.default.createElement("option", {
      key: i,
      value: value[valueKey],
      disabled: value[valueKey] === '_separator'
    }, value[labelKey]);
  }))), error ? _react.default.createElement(_ErrorLabel.default, {
    text: error
  }) : void 0);
};

var _default = (0, _enhanceFormControl.default)(Select);

exports.default = _default;